<div id="main" class="site-main- clearfix" style="margin-top: 95px">
    <div id="hero_alt" class="content_section">
        <div class="content_section_inner nopadding">
            <div class="inner">
                <div class="inner_content">
                    <h1>Terms of Service</h1>
                </div>
            </div>
        </div>
    </div>
    <div id="primary" class="content-area full">
        <div id="content" class="site-content" role="main">
            <article
                id="post-7955"
                class="come-out post-7955 page type-page status-publish has-post-thumbnail hentry come-in"
            >
                <div
                    id="narrow_wys-block_6114c64824451"
                    class="content_section narrow_wys"
                >
                    <div class="content_section_inner">
                        <div class="inner">
                            <div class="inner_content wysiwyg">
                                <p>
                                    <span style="color: #000000"
                                        ><b>Last Updated</b>:&nbsp; March 18,
                                        2023</span
                                    >
                                </p>
                                <p>
                                    <span
                                        style="
                                            color: #000000;
                                            font-weight: 500;
                                            font-size: 20px;
                                            color: #ff6e42;
                                        "
                                    >
                                        Terms and Conditions of Use<a
                                            style="
                                                color: rgb(0, 0, 0);
                                                cursor: pointer;
                                            "
                                        ></a
                                    ></span>
                                </p>
                                <p>
                                    <span style="color: #000000"
                                        >READ THE FOLLOWING TERM AND CONDITIONS
                                        CAREFULLY BEFORE USING THIS SITE. BY
                                        USING OR ACCESSING THIS SITE, YOU
                                        ACKNOWLEDGE THAT YOU HAVE READ THESE
                                        TERMS OF USE ("AGREEMENT"), AND THAT YOU
                                        ACCEPT AND WILL BE BOUND BY THE
                                        AGREEMENT.</span
                                    >
                                </p>
                                <ol>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b>Definitions.&nbsp;</b></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b></b>The following terms,
                                                    when used in this Agreement,
                                                    shall have the following
                                                    meanings.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b></b>"Content" shall mean
                                                    all information, data, or
                                                    other material, in any form
                                                    or media, contained in,
                                                    obtained from, or relating
                                                    to the Site, including all
                                                    results obtained from the
                                                    Site."Site" shall mean any
                                                    LeanQubit PVT. LTD. internet
                                                    site, page (and all
                                                    sub-pages), uniform resource
                                                    locator ("URL"), domain
                                                    location, and all
                                                    information and Content
                                                    thereon.
                                                </span>
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >TRADEMARK NOTICE.&nbsp;</b
                                            ></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >Marks used on this Site,
                                                    including "LeanQubit.", the
                                                    LeanQubit. logo (
                                                    “<b>LeanQubit</b>”) and
                                                    "LeanQubit", are owned by
                                                    LeanQubit PVT. LTD.. Unless
                                                    otherwise noted on the Site,
                                                    all other trademarks,
                                                    service marks, and logos
                                                    used in this Site are the
                                                    trademarks, service marks or
                                                    logos of their respective
                                                    owners.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >LICENSE GRANT & OWNERSHIP BY
                                                LeanQubit PVT. LTD.</b
                                            ></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>License.</b> Subject to
                                                    the terms and conditions of
                                                    this Agreement, and until
                                                    termination of the
                                                    Agreement, LeanQubit PVT.
                                                    LTD. grants you a
                                                    non-exclusive,
                                                    non-transferable, limited
                                                    license to view or print the
                                                    Content in this Site without
                                                    alterations, for personal,
                                                    non-commercial use only.
                                                    This limited license does
                                                    not apply to any media or
                                                    platform other than that of
                                                    the current Site.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>Ownership.</b> All
                                                    Content on the Site is (and
                                                    shall continue to be) owned
                                                    exclusively by LeanQubit
                                                    PVT. LTD. or others, and is
                                                    protected under applicable
                                                    copyrights, patents,
                                                    trademarks, trade dress,
                                                    and/or other proprietary
                                                    rights, and the copying,
                                                    redistribution, use or
                                                    publication by you of any
                                                    such Content or any part of
                                                    the Site is prohibited.
                                                    Under no circumstances will
                                                    you acquire any ownership
                                                    rights or other interest in
                                                    any Content by or through
                                                    your use of the Site.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>

                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >RESTRICTIONS ON USE.&nbsp;</b
                                            ></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >Concerning your usage of
                                                    this Site or any Content,
                                                    you agree not to knowingly:
                                                    (i) use any device, software
                                                    or technique to interfere
                                                    with or attempt to interfere
                                                    with the proper working of
                                                    the Site; (ii) post or
                                                    transmit to the Site any
                                                    unlawful, fraudulent,
                                                    harassing, libelous, or
                                                    obscene information of any
                                                    kind; (iii) post or send to
                                                    the Site any information
                                                    that contains a computer
                                                    virus, bug, or other harmful
                                                    item; (iv) publish, perform,
                                                    distribute, prepare
                                                    derivative works, copy,
                                                    reverse engineer, or use the
                                                    Content (other than as
                                                    expressly permitted herein);
                                                    (v) post or transmit into or
                                                    on the Site any information
                                                    in violation of another
                                                    party's copyright or
                                                    intellectual property
                                                    rights; (vi) take any action
                                                    which imposes an
                                                    unreasonable or
                                                    disproportionately large
                                                    burden on LeanQubit
                                                    infrastructure or resources;
                                                    (vii) redeliver any of the
                                                    Content using "framing",
                                                    hyperlinks, or other
                                                    technology without the
                                                    express written permission
                                                    of LeanQubit PVT. LTD.; or,
                                                    (viii) use any device or
                                                    technology to provide
                                                    repeated automated attempts
                                                    to access password-protected
                                                    portions of the Site.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >You acknowledge that
                                                    LeanQubit PVT. LTD. has the
                                                    right, but no obligation, to
                                                    monitor the Site and to
                                                    disclose any information
                                                    necessary to operate the
                                                    Site, to protect LeanQubit
                                                    PVT. LTD., and the customers
                                                    of LeanQubit PVT. LTD., and
                                                    to comply with legal
                                                    obligations or governmental
                                                    requests. LeanQubit PVT.
                                                    LTD. reserves the right to
                                                    refuse to post or to remove
                                                    any information on the Site,
                                                    in whole or in part, for any
                                                    reason.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >You represent and warrant
                                                    that by using the Site, you
                                                    have read and agree to this
                                                    Agreement and have the legal
                                                    capacity to agree to the
                                                    terms of this
                                                    Agreement.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >YOUR SITE ACTIVITIES.&nbsp;</b
                                            ></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >If you are allowed access
                                                    to password-protected areas
                                                    of the Site, you agree to
                                                    keep your password
                                                    confidential, and to send
                                                    notice to LeanQubit PVT.
                                                    LTD. within 24 hours if your
                                                    password is compromised. You
                                                    acknowledge that LeanQubit
                                                    PVT. LTD. neither endorses
                                                    nor is affiliated with any
                                                    linked site and is not
                                                    responsible for any
                                                    information that appears on
                                                    the linked site. You
                                                    acknowledge that (i) the
                                                    internet is a network of
                                                    computers worldwide, and
                                                    that any information
                                                    submitted by you to
                                                    LeanQubit PVT. LTD.
                                                    necessarily is routed via
                                                    third party computers to
                                                    LeanQubit PVT. LTD., (ii)
                                                    LeanQubit PVT. LTD. is not
                                                    responsible for lapses in
                                                    online security and does not
                                                    assume liability for
                                                    improper use of your
                                                    information by a third
                                                    party.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >SUBMISSIONS OF INFORMATION BY
                                                YOU. </b
                                            >If you submit information to the
                                            Site, you grant LeanQubit PVT. LTD.
                                            a nonexclusive, worldwide,
                                            royalty-free license to (in any
                                            media now known or not currently
                                            known or invented) link to, utilize,
                                            use, copy, exploit, and prepare
                                            derivative works of the submitted
                                            information. No Information you
                                            submit shall be deemed confidential.
                                            However, LeanQubit PVT. LTD. agrees
                                            to use your information in
                                            accordance with the privacy policy
                                            of LeanQubit PVT. LTD. applicable to
                                            personally identifiable user data.
                                            YOU RETAIN OWNERSHIP OF ANY
                                            COPYRIGHTS OR OTHER INTELLECTUAL
                                            PROPERTY RIGHTS APPLICABLE TO ANY
                                            INFORMATION YOU SUBMIT TO LeanQubit
                                            PVT. LTD.</span
                                        >
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b>APPLICABILITY & COOPERATION. </b
                                            >LeanQubit PVT. LTD. reserves the
                                            right to limit the provision of any
                                            product or service to any person,
                                            geographic area or jurisdiction as
                                            it so desires, or as required by
                                            law. LeanQubit PVT. LTD. in its sole
                                            discretion may add, delete or change
                                            the Content at any time, without
                                            notice to you.</span
                                        >
                                    </li>
                                    <!-- <li aria-level="1"><span style="color: #000000;"><b>No Warranty. </b>THE SITE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. USE OF THE SITE IS AT YOUR OWN RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SITE IS PROVIDED WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM YUGABYTE OR THROUGH THE SITE WILL CREATE ANY WARRANTY NOT EXPRESSLY STATED HEREIN. WITHOUT LIMITING THE FOREGOING, YUGABYTE, ITS SUBSIDIARIES, ITS AFFILIATES, AND ITS LICENSORS DO NOT WARRANT THAT THE CONTENT IS ACCURATE, RELIABLE OR CORRECT; THAT THE SITE WILL MEET YOUR REQUIREMENTS; THAT THE SITE WILL BE AVAILABLE AT ANY PARTICULAR TIME OR LOCATION, UNINTERRUPTED OR SECURE; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE SITE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. ANY CONTENT DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SITE IS DOWNLOADED AT YOUR OWN RISK AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE DEVICE OR LOSS OF DATA THAT RESULTS FROM SUCH DOWNLOAD OR YOUR USE OF THE SITE. FURTHER, YUGABYTE DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SITE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE OR ANY HYPERLINKED WEBSITE OR SITE, AND YUGABYTE WILL NOT BE A PARTY TO OR IN ANY WAY MONITOR ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR SITES. FEDERAL LAW, SOME STATES, PROVINCES AND OTHER JURISDICTIONS DO NOT ALLOW THE EXCLUSION AND LIMITATIONS OF CERTAIN IMPLIED WARRANTIES, SO THE ABOVE EXCLUSIONS MAY NOT APPLY TO YOU. THIS AGREEMENT GIVES YOU SPECIFIC LEGAL RIGHTS, AND YOU MAY ALSO HAVE OTHER RIGHTS WHICH VARY FROM STATE TO STATE. THE DISCLAIMERS AND EXCLUSIONS UNDER THIS AGREEMENT WILL NOT APPLY TO THE EXTENT PROHIBITED BY APPLICABLE LAW.</span></li> -->
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >LIMITED WARRANTY AND
                                                DISCLAIMER.</b
                                            ></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >DISCLAIMER OF WARRANTY.
                                                    LeanQubit PVT. LTD. AND ALL
                                                    CONTENT PROVIDERS MAKE NO
                                                    REPRESENTATION ABOUT THE
                                                    SUITABILITY OF THE CONTENT
                                                    HEREON. THIS SITE, AND
                                                    ACCESS TO ANY LINKED-SITE,
                                                    IS PROVIDED TO YOU BY ALL
                                                    CONTENT PROVIDERS "AS IS"
                                                    AND "AS AVAILABLE", WITH NO
                                                    REPRESENTATIONS OR
                                                    WARRANTIES OF ANY KIND,
                                                    EITHER EXPRESSED OR IMPLIED,
                                                    INCLUDING, BUT NOT LIMITED
                                                    TO THE IMPLIED WARRANTIES OF
                                                    MERCHANTABILITY, FITNESS FOR
                                                    A PARTICULAR PURPOSE,
                                                    ACCURACY, AND
                                                    NON-INFRINGEMENT. YOU HEREBY
                                                    DISCLAIM ALL WARRANTIES BY
                                                    LeanQubit PVT. LTD. RELATING
                                                    TO YOUR USAGE OF THE SITE.
                                                    YOU ACKNOWLEDGE THAT YOUR
                                                    ACCESS TO THE SITE WILL NOT
                                                    BE FREE OF INTERRUPTIONS,
                                                    THAT THE INFORMATION HEREIN
                                                    MAY CONTAIN BUGS, ERRORS,
                                                    TECHNICAL INACCURACIES,
                                                    PROBLEMS OR OTHER
                                                    LIMITATIONS, AND THAT THE
                                                    SITE MAY BE UNAVAILABLE FROM
                                                    TIME TO TIME. YOU ASSUME
                                                    TOTAL RESPONSIBILITY AND
                                                    RISK FOR YOUR USAGE OF THE
                                                    SITE AND SITE-RELATED
                                                    SERVICES.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >LIMITATION OF LIABILITY.
                                                    UNDER NO CIRCUMSTANCES WILL
                                                    ANY OF THE CONTENT PROVIDERS
                                                    BE LIABLE OR RESPONSIBLE FOR
                                                    ANY DIRECT, INDIRECT,
                                                    INCIDENTAL, CONSEQUENTIAL
                                                    (INCLUDING DAMAGES FROM LOSS
                                                    OF BUSINESS, LOST PROFITS,
                                                    LITIGATION, OR THE LIKE),
                                                    SPECIAL, EXEMPLARY, PUNITIVE
                                                    OR OTHER DAMAGES, UNDER ANY
                                                    LEGAL THEORY, ARISING OUT OF
                                                    OR IN ANY WAY RELATING TO
                                                    THE SITE, YOUR SITE USE, OR
                                                    THE CONTENT, EVEN IF ADVISED
                                                    OF THE POSSIBILITY OF SUCH
                                                    DAMAGES. YOUR SOLE REMEDY
                                                    FOR DISSATISFACTION WITH THE
                                                    SITE AND/OR CONTENT IS TO
                                                    CEASE ALL OF YOUR SITE USE.
                                                    You may have additional
                                                    rights under certain laws
                                                    (including consumer laws)
                                                    which do not allow the
                                                    exclusion of implied
                                                    warranties, or the exclusion
                                                    or limitation of certain
                                                    damages. If these laws apply
                                                    to you, the exclusions or
                                                    limitations in this
                                                    Agreement that directly
                                                    conflict with such laws may
                                                    not apply to you.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b
                                                >CONTACTING LeanQubit PVT.
                                                LTD.</b
                                            ></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >Should you desire to
                                                    contact LeanQubit PVT. LTD.,
                                                    you may do so at the contact
                                                    details mentioned in the
                                                    website.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b>MISCELLANEOUS</b></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>Equitable Relief. </b
                                                    >You acknowledge that any
                                                    breach by you of the
                                                    provisions of the Agreement
                                                    will cause irreparable
                                                    damage to LeanQubit PVT.
                                                    LTD. or others and that a
                                                    remedy at law will be
                                                    inadequate. Therefore, in
                                                    addition to any and all
                                                    other legal or equitable
                                                    remedies, LeanQubit PVT.
                                                    LTD. and others will be
                                                    entitled to injunctive
                                                    relief for any breach of
                                                    this Agreement.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>Severability. </b>In the
                                                    event that any of the
                                                    provisions of this Agreement
                                                    shall be held by a court or
                                                    other tribunal of competent
                                                    jurisdiction to be
                                                    unenforceable, such
                                                    provisions shall be limited
                                                    or eliminated to the minimum
                                                    extent necessary so that
                                                    this Agreement shall
                                                    otherwise remain in full
                                                    force and effect and
                                                    enforceable.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b
                                                        >Entire
                                                        Agreement/Severability. </b
                                                    >This Agreement constitutes
                                                    the entire agreement between
                                                    you and LeanQubit PVT. LTD.
                                                    pertaining to the subject
                                                    matter hereof. You agree to
                                                    review this Agreement prior
                                                    to any usage of the Site,
                                                    and each usage of the Site
                                                    by you shall constitute and
                                                    be deemed your unconditional
                                                    acceptance of this
                                                    Agreement. This Agreement
                                                    may be prospectively
                                                    modified by LeanQubit PVT.
                                                    LTD. at any time without
                                                    notice, by posting a revised
                                                    Agreement on the Site.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>Termination. </b>This
                                                    Agreement may be terminated
                                                    by either party, in its sole
                                                    and absolute discretion, at
                                                    any time and for any reason
                                                    (with or without cause),
                                                    with or without notice. If
                                                    the Agreement is terminated,
                                                    you agree to cease all
                                                    access and usage of the Site
                                                    and, upon request by
                                                    LeanQubit PVT. LTD., to
                                                    return all information in
                                                    your possession relating to
                                                    the Site, and all copies
                                                    thereof.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b
                                                        >Survival of Certain
                                                        Provisions.
                                                    </b>
                                                    Any and all provisions or
                                                    obligations contained in
                                                    this Agreement which by
                                                    their nature or effect are
                                                    required or intended to be
                                                    observed, kept or performed
                                                    after termination of this
                                                    Agreement will survive the
                                                    termination of this
                                                    Agreement and remain binding
                                                    upon and for the benefit of
                                                    the parties, their
                                                    successors and permitted
                                                    assignees.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>Waiver. </b> No delay or
                                                    omission to exercise any
                                                    right or remedy accruing to
                                                    LeanQubit PVT. LTD. upon any
                                                    breach or default by you
                                                    shall constitute a waiver by
                                                    LeanQubit PVT. LTD. of any
                                                    breach or default.</span
                                                >
                                            </li>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    ><b>Conflicts. </b> If this
                                                    Agreement conflicts with a
                                                    provision of any other
                                                    contract between you and
                                                    LeanQubit PVT. LTD. relating
                                                    to the Site, the provision
                                                    in such other Agreement
                                                    shall govern.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b>Compliance with Laws.</b></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >You shall be responsible
                                                    for complying with all
                                                    applicable governmental
                                                    regulations of the United
                                                    States (including US export
                                                    laws) and any foreign
                                                    country (where applicable)
                                                    with respect to the use of
                                                    the Site.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                    <li aria-level="1">
                                        <span
                                            style="
                                                color: #000000;
                                                font-weight: 700;
                                            "
                                            ><b>Agreement.</b></span
                                        >
                                        <ol>
                                            <li aria-level="2">
                                                <span style="color: #000000"
                                                    >This Agreement shall be
                                                    subject to, and construed in
                                                    conformity with, the laws of
                                                    the State of Ohio, United
                                                    States of America. The
                                                    parties hereby submit to the
                                                    jurisdiction of the courts
                                                    in the State of Ohio, USA.
                                                    Neither party shall bring a
                                                    legal action against the
                                                    other more than two (2)
                                                    years after the cause of
                                                    action arose unless
                                                    otherwise provided by local
                                                    law without the possibility
                                                    of contractual waiver or
                                                    limitation.</span
                                                >
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </div>
</div>
